import { render, staticRenderFns } from "./singleVLIS.vue?vue&type=template&id=f7571578&scoped=true&"
import script from "./singleVLIS.vue?vue&type=script&lang=js&"
export * from "./singleVLIS.vue?vue&type=script&lang=js&"
import style0 from "./singleVLIS.vue?vue&type=style&index=0&id=f7571578&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7571578",
  null
  
)

export default component.exports